import React, { FC } from 'react';
import cls from './MenuItem.module.css';
import classNames from 'classnames';

export const MenuItem = ({ children, onClick }) => {
    return (
        <div onClick={onClick} className={classNames(cls.wrapper)}>
            {children}
        </div>
    );
};
